exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countDownForUser[data-v-11bfad55]{padding-left:25px}.countDownForUser .card[data-v-11bfad55]{padding:18px}.info__period[data-v-11bfad55]{color:#818a91;margin-right:1.4rem}.btn__out[data-v-11bfad55]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn__out .btn__active[data-v-11bfad55]{background:#24d67c;font-weight:700;color:#fff;padding:1.2rem 1.6rem;border-radius:4px;margin-top:1rem;-webkit-transition:all .3s;transition:all .3s;font-size:1.3rem}.btn__out .btn__active[data-v-11bfad55]:hover{background:#54d895}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11bfad55","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise/components/countdownForUser.vue
// module id = xpE+
// module chunks = 0